import EmailsInput from "./EmailsInput";

export default EmailsInput;
